import template from "./template.html";
import config from "../config";

export default function (editor) {
  const { DomComponents, BlockManager } = editor;

  DomComponents.addType("features-faq", {
    isComponent: (el: HTMLElement) => el.classList && el.classList.contains("solo-landing-faq"),
    model: {
      defaults: {
        draggable: true,
        removable: true,
        selectable: true,
        hoverable: true,
        stylable: ["background-color"],
      },
    },
  });
  DomComponents.addType("features-faq-question", {
    isComponent: (el: HTMLElement) => el.classList && el.classList.contains("solo-landing-faq__question"),
    model: {
      defaults: {
        removable: true,
        selectable: true,
        copyable: true,
        hoverable: true,
        stylable: ["background-color"],
      },
    },
  });

  BlockManager.add("features-faq", {
    ...config,
    label: "FAQ",
    content: template,
  });
}
